import { render, staticRenderFns } from "./ModuloCentroCirurgico.vue?vue&type=template&id=110091c0&"
import script from "./ModuloCentroCirurgico.vue?vue&type=script&lang=js&"
export * from "./ModuloCentroCirurgico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports